function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState, useCallback, useContext } from 'react';
import { useSpring, animated, useTransition } from 'react-spring';
import { useDrag } from 'react-use-gesture';
import styled, { ThemeContext } from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "DraggableCard__Wrapper",
  componentId: "sc-1hrmppy-0"
})(["width:100%;overflow:hidden;position:relative;outline:none;"]);
var LeftButtons = styled(animated.div).withConfig({
  displayName: "DraggableCard__LeftButtons",
  componentId: "sc-1hrmppy-1"
})(["display:grid;grid-column-gap:", "px;grid-template-columns:1fr 1fr;position:absolute;top:0;right:calc(100% + 1px);height:100%;"], function (_ref) {
  var theme = _ref.theme;
  return theme.draggable.gap;
});
var RightButtons = styled(animated.div).withConfig({
  displayName: "DraggableCard__RightButtons",
  componentId: "sc-1hrmppy-2"
})(["display:grid;grid-column-gap:", "px;grid-template-columns:1fr 1fr;position:absolute;top:0;left:calc(100% + 1px);height:100%;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.draggable.gap;
});

var DraggableCard = function DraggableCard(_ref3) {
  var _leftButtonsRef$curre, _rightButtonsRef$curr, _wrapperRef$current;

  var leftButtons = _ref3.leftButtons,
      rightButtons = _ref3.rightButtons,
      children = _ref3.children;

  var _useContext = useContext(ThemeContext),
      draggableTheme = _useContext.draggable;

  var blockGap = (draggableTheme === null || draggableTheme === void 0 ? void 0 : draggableTheme.gap) || 0;
  var minimumDelta = (draggableTheme === null || draggableTheme === void 0 ? void 0 : draggableTheme.delta) || 0;
  var rangeToCloseSwipe = (draggableTheme === null || draggableTheme === void 0 ? void 0 : draggableTheme.rangeToClose) || 10;
  var vibrationDuration = (draggableTheme === null || draggableTheme === void 0 ? void 0 : draggableTheme.vibrationDuration) || 50;
  var rightButtonsRef = useRef(null);
  var leftButtonsRef = useRef(null);
  var wrapperRef = useRef(null);
  var leftPanelWidth = (leftButtonsRef === null || leftButtonsRef === void 0 ? void 0 : (_leftButtonsRef$curre = leftButtonsRef.current) === null || _leftButtonsRef$curre === void 0 ? void 0 : _leftButtonsRef$curre.offsetWidth) || 0;
  var rightPanelWidth = (rightButtonsRef === null || rightButtonsRef === void 0 ? void 0 : (_rightButtonsRef$curr = rightButtonsRef.current) === null || _rightButtonsRef$curr === void 0 ? void 0 : _rightButtonsRef$curr.offsetWidth) || 0;
  var wrapperWidth = (wrapperRef === null || wrapperRef === void 0 ? void 0 : (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.offsetWidth) || 0;
  var rangeToActivateLongSwipe = wrapperWidth / 2;

  var _useSpring = useSpring(function () {
    return {
      x: 0
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      x = _useSpring2[0].x,
      setPanelTransform = _useSpring2[1];

  var _useSpring3 = useSpring(function () {
    return {
      x: 0
    };
  }),
      _useSpring4 = _slicedToArray(_useSpring3, 2),
      leftX = _useSpring4[0].x,
      setLeftMargin = _useSpring4[1];

  var _useSpring5 = useSpring(function () {
    return {
      x: 0
    };
  }),
      _useSpring6 = _slicedToArray(_useSpring5, 2),
      rightX = _useSpring6[0].x,
      setRightMargin = _useSpring6[1];

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      lastPosition = _useState2[0],
      setLastPosition = _useState2[1];

  var changedLeftActiveZone = useRef(false);
  var changedRightActiveZone = useRef(false);
  var transitions = useTransition(true, {
    from: {
      opacity: 1
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  var resetSwipe = useCallback(function () {
    setPanelTransform({
      x: 0
    });
    setLeftMargin({
      x: 0
    });
    setRightMargin({
      x: 0
    });
    setLastPosition(0);
    changedLeftActiveZone.current = false;
    changedRightActiveZone.current = false;
  }, [setLeftMargin, setPanelTransform, setRightMargin]);
  var setMovement = useCallback(function (movementX, last) {
    setPanelTransform({
      x: movementX
    });

    if (movementX <= leftPanelWidth) {
      setLeftMargin({
        x: movementX
      });
    }

    if (movementX >= -rightPanelWidth) {
      setRightMargin({
        x: movementX
      });
    }

    if (last) {
      setLastPosition(movementX);
    }
  }, [leftPanelWidth, rightPanelWidth, setLeftMargin, setPanelTransform, setRightMargin]);
  var bind = useDrag(function (_ref4) {
    var down = _ref4.down,
        last = _ref4.last,
        _ref4$movement = _slicedToArray(_ref4.movement, 1),
        movementX = _ref4$movement[0],
        axis = _ref4.axis;

    var currentDragPosition = lastPosition + movementX;
    var positionToActivateRightPanel = currentDragPosition < -rangeToActivateLongSwipe;
    var positionToActivateLeftPanel = currentDragPosition > rangeToActivateLongSwipe; // touchStart

    if (axis === 'x') {
      if (down) {
        setMovement(currentDragPosition, last);

        if (currentDragPosition > leftPanelWidth) {
          setLeftMargin({
            x: leftPanelWidth
          });
        }

        if (positionToActivateLeftPanel && !changedLeftActiveZone.current) {
          navigator.vibrate(vibrationDuration);
          changedLeftActiveZone.current = true;
        } else if (!positionToActivateLeftPanel && changedLeftActiveZone.current) {
          navigator.vibrate(vibrationDuration);
          changedLeftActiveZone.current = false;
        }

        if (currentDragPosition < -rightPanelWidth) {
          setRightMargin({
            x: -rightPanelWidth
          });
        }

        if (positionToActivateRightPanel && !changedRightActiveZone.current) {
          navigator.vibrate(vibrationDuration);
          changedRightActiveZone.current = true;
        } else if (!positionToActivateRightPanel && changedRightActiveZone.current) {
          navigator.vibrate(vibrationDuration);
          changedRightActiveZone.current = false;
        } // touchEnd

      } else {
        // left panel manipulation
        if (currentDragPosition > minimumDelta && currentDragPosition < rangeToActivateLongSwipe) {
          setMovement(leftPanelWidth, last);
        } // right panel manipulation


        if (currentDragPosition < -minimumDelta && currentDragPosition > -rangeToActivateLongSwipe) {
          setMovement(-rightPanelWidth, last);
        }

        if (positionToActivateRightPanel) {
          setMovement(-(rightPanelWidth + blockGap), last);
        } // close when left panel open


        if (movementX > rangeToCloseSwipe && lastPosition < 0 && currentDragPosition < -minimumDelta) {
          resetSwipe();
        } // close when right panel open


        if (movementX < -rangeToCloseSwipe && lastPosition > 0 && currentDragPosition > minimumDelta) {
          resetSwipe();
        } // avoid unnecessary moves


        if (Math.abs(currentDragPosition) < minimumDelta) {
          setMovement(0, last);
        }
      }
    }
  });
  return React.createElement(React.Fragment, null, transitions(function (style, active) {
    return active && React.createElement(animated.div, {
      tabIndex: 0,
      style: style
    }, React.createElement(Wrapper, {
      ref: wrapperRef,
      tabIndex: 0,
      onTouchStart: function onTouchStart() {
        var _wrapperRef$current2;

        return (_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.focus();
      },
      onBlur: resetSwipe
    }, leftButtons && React.createElement(LeftButtons, _extends({
      ref: leftButtonsRef
    }, bind(), {
      style: {
        x: leftX
      }
    }), leftButtons), React.createElement(animated.div, _extends({}, bind(), {
      style: {
        x: x
      }
    }), children), rightButtons && React.createElement(RightButtons, _extends({
      ref: rightButtonsRef
    }, bind(), {
      style: {
        x: rightX
      }
    }), rightButtons)));
  }));
};

export default DraggableCard;